import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "row iosHeaderHeight full-width" };
import { computed, onBeforeUnmount, onMounted, provide, ref, watch } from 'vue';
import { useAccountStore } from 'src/stores/account';
import { useSizeStore } from 'src/stores/size';
import useQuasar from 'quasar/src/composables/use-quasar/use-quasar.js';
import { useRoute } from 'vue-router';
import { debounceTime, filter, tap } from 'rxjs/operators';
import { rxInitSubjectCallback, useObservable } from 'src/plugins/rxjs/base';
import { defineComponent } from 'vue';
const __default__ = defineComponent({
    name: 'general-header'
});
export default /*@__PURE__*/ _defineComponent({
    ...__default__,
    props: {
        homeHeader: Boolean
    },
    setup(__props) {
        const accountStore = useAccountStore();
        const sizeStore = useSizeStore();
        const $q = useQuasar();
        const vueRoute = useRoute();
        /****
         * User
         *****/
        const user = computed(() => accountStore.user);
        /****
         * Misc
         ****/
        const isOwner = computed(() => {
            if (user.value && user.value.profile_role_detail) {
                return (user.value.profile_role_detail.filter(items => {
                    return ['admin', 'super_admin'].indexOf(items.role_name) > -1;
                }).length > 0);
            }
            return false;
        });
        provide('isOwner', isOwner.value);
        /******
         * Header height
         ******/
        const headerRef = ref(null);
        const headerHeight = computed({
            get: () => sizeStore.headerHeight,
            set: (newValue) => {
                sizeStore.setHeaderHeight(newValue);
            }
        });
        const { subject: getHeight$ } = rxInitSubjectCallback();
        useObservable(getHeight$.pipe(debounceTime(500), filter(() => headerRef.value !== null), tap(() => {
            // when header height has changed
            if ((headerHeight.value !== headerRef.value.clientHeight) &&
                headerRef.value.clientHeight) {
                headerHeight.value = headerRef.value.clientHeight;
            }
        })));
        /*****
         * Detect window size change affecting header height
         * change
          *****/
        // detect if cookies are enabled
        const cookiesEnabled = ref(true);
        function resizeDetect() {
            getHeight$.next('');
        }
        watch(vueRoute, () => {
            getHeight$.next('');
        });
        onMounted(() => {
            if (typeof window !== "undefined") {
                window.addEventListener('resize', resizeDetect, { passive: true, capture: true });
            }
            if (typeof navigator !== 'undefined') {
                cookiesEnabled.value = navigator.cookieEnabled;
            }
            getHeight$.next('');
        });
        onBeforeUnmount(() => {
            if (typeof window !== "undefined") {
                window.removeEventListener('resize', resizeDetect, { capture: true });
            }
        });
        return (_ctx, _cache) => {
            const _component_q_banner = _resolveComponent("q-banner");
            return (_openBlock(), _createElementBlock("div", {
                ref_key: "headerRef",
                ref: headerRef,
                bordered: "",
                class: _normalizeClass(["full-width grey8-white-text-color", {
                        'app-header-bottom bg-transparent': __props.homeHeader,
                        'white-dark-background app-header-bottom-ld-responsive': !__props.homeHeader
                    }])
            }, [
                _withDirectives(_createElementVNode("div", _hoisted_1, null, 512), [
                    [_vShow, _unref($q).platform.is.capacitor && _unref($q).platform.is.ios]
                ]),
                _withDirectives(_createVNode(_component_q_banner, {
                    "inline-actions": "",
                    dense: "",
                    class: "text-white bg-negative q-py-none text-caption"
                }, {
                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                        _createTextVNode(" You have to enable cookies to log in ")
                    ])),
                    _: 1,
                    __: [0]
                }, 512), [
                    [_vShow, !cookiesEnabled.value && !__props.homeHeader]
                ]),
                _renderSlot(_ctx.$slots, "default")
            ], 2));
        };
    }
});
